<template>
  <div v-if="prospectStats" class="md:ut-flex ut-justify-between ut-mb-12 ut-items-start">
    <div class="md:ut-w-1/2 ut-flex ut-justify-between ut-content-start ut-ml-0 ut-items-stretch">
      <article class="ut-w-1/2 ut-pr-2 md:ut-pr-3 ut-m-0">
        <div class="ut-card-base md:ut-h-48 ut-pt-6 md:ut-pt-8 ut-px-4 md:ut-px-6">
          <strong class="ut-text-3xl">{{ tocallCount }}</strong>
          <h3 class="ut-text-sm ut-opacity-50 ut-mt-2 md:ut-mt-3 md:ut-mb-8">Prospects to call</h3>
          <a href="#to-call" class="ut-text-green-400 ut-hidden md:ut-block">View</a>
        </div>
      </article>
      <article class="ut-w-1/2 ut-pl-2 md:ut-pl-3 ut-ml-0">
        <div class="ut-card-base md:ut-h-48 ut-pt-6 md:ut-pt-8 ut-px-4 md:ut-px-6">
          <strong class="ut-text-3xl">{{ appraisalsCount }}</strong>
          <h3 class="ut-text-sm ut-opacity-50 ut-mt-2 md:ut-mt-3 md:ut-mb-8">Appraisals</h3>
          <a href="#appraisals" class="ut-text-green-400 ut-hidden md:ut-block">View</a>
        </div>
      </article>
    </div>
      <article v-if="showAuthError" class="md:ut-w-1/2 md:ut-pl-3 ut-ml-0 md:ut-mt-0 ut-mt-5">
        <info-card @click.native="showModal('prospecting-reconnect-crm-modal')" class="ut-w-full ut-card-base ut-cursor-pointer">
          <p class="ut-text-sm">Oh no! It seems your <strong>MyDesktop connection</strong> has <strong>dropped out</strong>.
        This could be due to you changing your password. Without an active connection,
        we cannot prospect new contacts for you. Re-login again <strong>here </strong>to turn on the connection again.</p>
        <button class="btn ut-mt-3 ut-bg-red-300 ut-border-red-400 ut-text-neutral-001">Re-connect now</button>
        </info-card>
      </article>
  </div>
</template>

<script>
import InfoCard from '@/components/Cards/InfoCard.vue';

export default {
  name: 'prospectingOpportunitiesTop',
  components: {
    InfoCard,
  },
  props: {
    prospectStats: {
      required: true,
    },
    showAuthError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      myDesktopAuthError: `Oh no! It seems your MyDesktop connection has dropped out.
        This could be due to you changing your password. Without an active connection,
        we cannot prospect new contacts for you. Re-login again here to turn on the connection again.`,
    };
  },
  computed: {
    tocallCount() {
      return this.prospectStats.newProspectsCount
        + this.prospectStats.attemptedProspectsForAttentionCount
        + this.prospectStats.prospectsToFollowUpForAttentionCount
        + this.prospectStats.prospectsBookedAppraisalForAttentionCount;
    },
    appraisalsCount() {
      return this.prospectStats.prospectsBookedAppraisalCount
        + this.prospectStats.appraisedProspectsCount;
    },
  },
  mounted() {},
  watch: {},
  created() {},
  methods: {
    showModal(name, data) {
      this.$modal.show(name, data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 p {
    line-height: 1.3;
  }
</style>
